/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { Component } from 'react';
import {alert} from 'util/alert'
import locale from './locale'
import DropdownSelect from 'components/UI/Form/Fields/DropdownSelect';
import ReactSelect from 'components/UI/Form/Fields/ReactSelect';
import getClassBy from 'controllers/class/getClassBy'
// import Editor from 'vendor/react-medium-editor';
import ReactQuill from 'react-quill';

import './Modal.scss';

export const MIN_INTERVAL_FOR_LEGIT_INPUT = 200;

class ModalContent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      dropdownOption: [],
      accouncementInfo:{
        title: '',
        content: '',
        class_id_list: [],
      },
    }
  }

  componentWillMount(){
    const schoolId = localStorage.getItem('schoolId')
    const {data, class_id_list, onFormChange} = this.props
    let arr = []
    getClassBy({schoolId, type: 'all', state: 'current', detail: 0})
    .then((res) => {
      if(res.classCount > 0){
        arr.push({label: __('All', locale), value: 0})
        res.classList.map((cls) => {
          arr.push({label: cls.className, value: cls.classID})
        })
        this.setState({dropdownOption: arr})
      }
    })

    if(data){
      this.setState({
        accouncementInfo: {
          ...this.state.accouncementInfo,
          title: data.title,
          content: data.content,
          class_id_list: class_id_list == 'all' ? [{label: __('All', locale), value: 0}] : class_id_list
        },
      }, () => { onFormChange(this.state.accouncementInfo) })
    }
  }


  renderTargetClass(){
    if(this.props.class_id_list !=='all' && this.props.data.send_to.length>0){
      let classList = this.props.data.send_to.map((cls)=>{
        return <span className='targetClass'>{cls.class_name}</span>
      })
      return classList;
    }
    return <span className='targetClass'>{__('All', locale)}</span>;
  }
  render() {
    const {onFormChange, allowEdit, data} = this.props
    const {dropdownOption, accouncementInfo} = this.state
    const {title, content, class_id_list} = accouncementInfo
    return (
      <div className='announcement-modal-content'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-xs-3'>
              <span className='title-label'>{__('Title', locale)}</span>
              <span className='c-red'>*</span>
            </div>
            <div className='col-xs-9'>
              <input
                disabled={!allowEdit}
                className='form-control title'
                placeholder={__('Please enter announcement title', locale)}
                value={title}
                onChange={(e)=> {
                  this.setState({
                    accouncementInfo:{
                      ...this.state.accouncementInfo,
                      title: e.target.value,
                    }
                  }, () => {onFormChange(this.state.accouncementInfo)} )
                }}
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-xs-3'>
              <span className='for-label'>{__('For', locale)}</span>
              <span className='c-red'>*</span>
            </div>
            <div className='col-xs-9 '>
              {
                allowEdit &&
                <ReactSelect
                  value={class_id_list}
                  noCaret={false}
                  options={dropdownOption}
                  onChange={(id) => {
                    if(id.length >= 2 && id[0] == 0){
                      id.shift()
                    } else if (id.length >= 1 && id[0] != 0 && id.includes(0)){
                      for(let i = 0; i <= id.length; i++){
                        id.shift()
                      }
                    }

                    this.setState({
                      accouncementInfo:{
                        ...this.state.accouncementInfo,
                        class_id_list: id,
                      }
                    }, () => {onFormChange(this.state.accouncementInfo)})
                  }}
                  multi={true}
                  placeholder={__('Please select announcement target', locale)}
                />
              } 
              {
                !allowEdit && 
                <div className='content-section'>
                  {this.renderTargetClass()}
                </div>
              }

            </div>
          </div>

          <div className='row'>
            <div className='col-xs-3'>
              <span className='contents-label'>{__('Content', locale)}</span>
              <span className='c-red'>*</span>
            </div>
            <div className='col-xs-9'>
              {!allowEdit && <div className='content-section' dangerouslySetInnerHTML={{ __html: content }}></div>}
              {allowEdit && <ReactQuill
                value={content || ''}
                onChange={(value) => {
                  this.setState({
                    accouncementInfo:{
                      ...this.state.accouncementInfo,
                      content: value,
                    }
                  }, () => {onFormChange(this.state.accouncementInfo)})
                }}
              />}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/Announcement/ModalContent.js